import * as React from 'react';
import { DeviceEncryptionAlert } from '../../../misc/components/DeviceEncryptionAlert';

interface VitaloJak1ConnectionStepsProps {
    onNext: () => void;
    onBack: () => void;
}

export const VitaloJak1ConnectionSteps = ({ onNext, onBack }: VitaloJak1ConnectionStepsProps) => {
    return (
        <>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="text-primary">Connect Device</h2>
                        <DeviceEncryptionAlert show={true} />
                    </div>
                    <div className="col-md-12">                 
                        <ol className="posh-list">
                            <li>Insert the CF card into the card reader</li>
                            <li>Connect the card reader to the computer you will use to access the web portal</li>
                        </ol>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={onNext}>Next</button>
                <button className="btn btn-primary btn-outline" onClick={onBack}>Back</button>
            </div>
        </>
    );
}
